const GP_Constants = Object.freeze({
    GIRL_MSG : "It's a Girl !"
    
});

export default GP_Constants;